import { useLayoutEffect, useEffect } from 'react'

/**
 * useIsomorphicLayoutEffect
 * @description A custom hook that is similar to useLayoutEffect, but its
 * effect is triggered after the initial render instead of before. and in a SSR environment returns a useEffect by default
 */
const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect

export { useIsomorphicLayoutEffect }
